package com.example.mystybag.login.model

data class SignatoryItem(
    val firstName: String = "",
    val lastName: String = "",
    val phoneNumber: String = "",
    val dialCode: String = ""
)
